
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/ellixi/zero2one",
      function () {
        return require("private-next-pages/brands/ellixi/zero2one.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/ellixi/zero2one"])
      });
    }
  